import Vue from 'vue'
import Router from 'vue-router'
import Price from '../app/price'
import Course from '../app/course'

import Login from '../app/login'
import NewsEdit from '../app/newsEdit'
import material from '../app/material'
import Test from '../app/test'
import Recycle from '../app/recycle'

import userInfo from '../app/userInfo'
import aliPay from '../app/aliPay'
import wxAuth from '../app/wxAuth'
import articles from '../app/articles'
import agree from '../app/agree'
import disclaimer from '../app/disclaimer'
import bindMobile from '../components/bindMobile'
import orders from '../app/orders'
import invoice from '../app/invoice'

import chat from '../app/chat.vue'
import write from '../app/write.vue'

Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      name: 'write',
      component: write
    },
    {
      path: '/write',
      name: 'write',
      component: write
    },
    {
      path: '/orders',
      name: 'orders',
      component: orders
    },
    {
      path: '/invoice',
      name: 'invoice',
      component: invoice
    },

    {
      path: '/bindMobile',
      name: 'bindMobile',
      component: bindMobile
    },
    {
      path: '/articles',
      name: 'articles',
      component: articles
    },

    {
      path: '/test',
      name: 'test',
      component: Test
    },
    {
      path: '/newsEdit',
      name: 'newsEdit',
      component: NewsEdit
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/price',
      name: 'price',
      component: Price
    },

    {
      path: '/chat',
      model: 'chat',
      component: chat
    },

    {
      path: '/course',
      name: 'course',
      component: Course
    },
    {
      path: '/material',
      name: 'material',
      component: material
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      component: userInfo
    },
    {
      path: '/aliPay',
      name: 'aliPay',
      component: aliPay
    },
    {
      path: '/wxAuth',
      name: 'wxAuth',
      component: wxAuth
    },
    {
      path: '/recycle',
      name: 'recycle',
      component: Recycle
    },
    {
      path: '/agree',
      name: 'agree',
      component: agree
    },
    {
      path: '/disclaimer',
      name: 'disclaimer',
      component: disclaimer
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js